import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Regist from "./views/Regist.vue";
import Login from "./views/Login.vue";
import NavigationBar from "./views/NavigationBar.vue";
import ReleaseHouse from "./views/ReleaseHouse.vue";
import Index from "./views/index.vue";
import HouseDetail from "./views/HouseDetail.vue";
import IndexPhone from "./views/IndexPhone.vue";
import MiniIndex from "./views/MiniIndex.vue";
import HouseList from "./views/HouseList.vue";
import PersonalCenter from "./views/PersonalCenter.vue";
import HouseEdit from "./views/HouseEdit.vue";
import Foot from "./views/Foot.vue";
import test from "./views/test.vue";
import ChooseCity from "./views/ChooseCity.vue";
import Findpassword from "./views/Findmima.vue";
import cookies from "vue-cookies";
import Chat from "./views/Chat.vue";

Vue.use(Router);

const router = new Router({
  base: process.env.BASE_URL,

  routes: [
    {
      path: "/",
      name: "index",
      component: Index,
    },
    {
      path: "/NavigationBar",
      name: "NavigationBar",
      component: NavigationBar,
    },
    {
      path: "/ChooseCity",
      name: "ChooseCity",
      component: ChooseCity,
      meta: {
        keepAlive: true, // 添加该字段，表示不需要使用公用底部
      },
    },
    {
      path: "/ReleaseHouse",
      name: "ReleaseHouse",
      meta: {
        requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      },
      component: ReleaseHouse,
    },

    {
      path: "/regist",
      name: "regist",
      component: Regist,
      meta: {
        footerkeepAlive: true, // 添加该字段，表示不需要使用公用底部
      },
    },

    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        footerkeepAlive: true, // 添加该字段，表示不需要使用公用底部
      },
    },
    {
      path: "/index",
      name: "index",
      component: Index,
    },
    {
      path: "/Chat",
      name: "Chat",
      component: Chat,
      meta: {
        footerkeepAlive: true,
      },
    },
    {
      path: "/Findpassword",
      name: "Findmima",
      component: Findpassword,
      meta: {
        footerkeepAlive: true, // 添加该字段，表示不需要使用公用底部
      },
    },

    {
      path: "/IndexPhone",
      name: "IndexPhone",
      meta: {
        keepAlive: true, //
      },
      component: IndexPhone,
    },

    {
      path: "/MiniIndex",
      name: "MiniIndex",
      meta: {
        keepAlive: true, //
        footerkeepAlive: true, //
      },
      component: MiniIndex,
    },

    {
      path: "/HouseDetail",
      name: "HouseDetail",
      component: HouseDetail,
    },

    {
      path: "/HouseList",
      name: "HouseList",
      component: HouseList,
    },

    {
      path: "/PersonalCenter",
      name: "PersonalCenter",
      component: PersonalCenter,
    },

    {
      path: "/test",
      name: "test",
      component: test,
    },

    {
      path: "/HouseEdit",
      name: "HouseEdit",
      component: HouseEdit,
    },

    {
      path: "/Foot",
      name: "Foot",
      component: Foot,
    },
  ],
});

router.beforeEach((to, from, next) => {
  // console.log(this.tool.getCookie("token"));
  // var coo = this.too.getCookie('token')
  // console.log(coo)
  if (to.matched.some((r) => r.meta.requireAuth)) {
    // console.log(localStorage.dcaw_token)
    // var tokenshow = sessionStorage.getItem('token');
    var tokenshow = cookies.get("userid", to.query.userid);
    if (tokenshow) {
      next();
    } else {
      next({
        path: "/login",
      });
    }
  } else {
    next();
  }
});

export default router;
